// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.detection-label {
  background: var(--page-bg);
  padding: 0.5rem 0;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.detection-label .detection-filter-wrap {
  flex-shrink: 0;
  padding: 0 0.5rem;
  margin-bottom: 0.5rem;
}
.detection-label .page-header {
  height: 44px;
  display: flex;
  align-items: center;
  margin: 0;
}
.detection-label .page-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--card);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  margin-bottom: 0.5rem;
}
.detection-label .page-header-title h5 {
  margin: 0;
  font-weight: 600;
  font-size: 1.15rem;
  color: var(--foreground);
}
.detection-label .page-header-title .btn-primary {
  background: var(--primary);
  border-color: var(--primary);
  color: var(--primary-foreground);
}
.detection-label .page-header-title .btn-primary:hover {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
}
.detection-label .main-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.75rem;
  width: 100%;
  overflow: hidden;
}
.detection-label .main-content > .left-col {
  flex: 0 0 15%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 1rem;
  overflow: hidden;
  background: var(--card) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.detection-label .main-content > .right-col {
  flex: 0 0 15%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 1rem;
  overflow: hidden;
  background: var(--card) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.detection-label .right-col {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}
.detection-label .center-col {
  flex: 0 0 70%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: hidden;
}
.detection-label .center-col .content-top {
  flex-shrink: 0;
  margin: 0;
  padding: 0.75rem;
  overflow-y: auto;
  background: var(--card) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.detection-label .center-col .content-top .active {
  background: var(--primary) !important;
  color: var(--primary-foreground) !important;
}
.detection-label .center-col .content-bottom {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: var(--page-bg-subtle) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.detection-label .right-col > .content-top {
  flex: 0 1 auto;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
  background: transparent !important;
  border: none;
  box-shadow: none;
}
.detection-label .right-col > .content-bottom {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: transparent !important;
  border: none;
  box-shadow: none;
}
.detection-label .right-col .card {
  background: var(--card) !important;
  color: var(--foreground) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.detection-label .right-col .content-top .card .card-header,
.detection-label .right-col .card-header-classes {
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%) !important;
  color: var(--primary-foreground) !important;
  border-bottom: none !important;
  border-radius: var(--radius) var(--radius) 0 0;
  padding: 0.75rem 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  box-sizing: border-box;
}
.detection-label .right-col .card-header-classes__title,
.detection-label .right-col .content-top .card .card-header h5 {
  color: var(--primary-foreground) !important;
  font-weight: 600;
  font-size: 1rem;
  margin: 0;
  flex-shrink: 0;
}
.detection-label .right-col .card-header-classes__actions {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.detection-label .right-col .content-top .card .card-header .btn-add-class,
.detection-label .right-col .card-header-classes .btn-add-class {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  background: var(--primary-foreground) !important;
  border: none !important;
  color: var(--primary) !important;
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.4rem 0.85rem;
  border-radius: var(--radius-sm);
  transition: background var(--transition), transform var(--transition-fast), box-shadow var(--transition);
  flex-shrink: 0;
}
.detection-label .right-col .content-top .card .card-header .btn-add-class:hover,
.detection-label .right-col .card-header-classes .btn-add-class:hover {
  background: var(--primary-foreground) !important;
  color: var(--primary-hover) !important;
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}
.detection-label {
  /* Empty state - Add Class button on right */
}
.detection-label .right-col .card-body-classes__empty {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 1rem;
  padding: 2rem 1.5rem;
  min-height: 140px;
}
.detection-label .right-col .card-body-classes__empty-text {
  margin: 0;
  font-size: 0.9rem;
  color: var(--muted-foreground);
  margin-right: auto;
}
.detection-label .right-col .btn-add-class--centered {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%) !important;
  color: var(--primary-foreground) !important;
  font-weight: 600;
  padding: 0.6rem 1.25rem !important;
  border-radius: var(--radius) !important;
  border: none !important;
  box-shadow: var(--shadow-glow);
}
.detection-label .right-col .btn-add-class--centered:hover {
  background: var(--primary-hover) !important;
  color: var(--primary-foreground) !important;
  transform: translateY(-2px);
  box-shadow: var(--shadow-glow);
}
.detection-label .right-col .content-bottom .card .card-header {
  background: var(--muted) !important;
  color: var(--foreground) !important;
  border-bottom: 1px solid var(--border) !important;
  border-radius: var(--radius) var(--radius) 0 0;
  padding: 0.75rem 1rem;
}
.detection-label .right-col .content-bottom .card .card-header h5 {
  color: var(--foreground) !important;
  font-size: 0.95rem;
  font-weight: 600;
}
.detection-label .right-col .content-bottom .card .card-header .btn-secondary {
  background: var(--secondary) !important;
  border-color: var(--border) !important;
  color: var(--secondary-foreground) !important;
  font-size: 0.8rem;
}
.detection-label .right-col .card-body {
  background: var(--card) !important;
  color: var(--foreground) !important;
  padding: 1rem !important;
}
.detection-label .right-col .card-body-classes {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.detection-label .right-col .detection-class-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem 0.65rem;
  border-radius: var(--radius-sm);
  border-left: 4px solid var(--class-color);
  background: var(--muted);
  color: var(--foreground);
  cursor: pointer;
  transition: background var(--transition), border-color var(--transition), box-shadow var(--transition);
}
.detection-label .right-col .detection-class-item:hover {
  background: var(--accent);
}
.detection-label .right-col .detection-class-item--active {
  background: var(--primary-soft) !important;
  color: var(--foreground) !important;
  border-left-color: var(--class-color);
  box-shadow: inset 0 0 0 1px var(--primary);
}
.detection-label .right-col .detection-class-item__swatch {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid var(--border-strong);
}
.detection-label .right-col .detection-class-item--active .detection-class-item__swatch {
  border-color: var(--border-strong);
}
.detection-label .right-col .detection-class-item__name {
  font-weight: 600;
  font-size: 0.85rem;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detection-label .right-col .detection-class-item__edit {
  flex-shrink: 0;
  padding: 0.25rem 0.4rem !important;
  background: transparent !important;
  border: none !important;
  color: inherit !important;
  opacity: 0.8;
}
.detection-label .right-col .detection-class-item__edit:hover {
  opacity: 1;
}
.detection-label .right-col .detection-class-item--active .detection-class-item__edit:hover {
  background: var(--accent) !important;
  border-radius: var(--radius-sm);
}
.detection-label .right-col .card-body-labeled {
  padding: 0.75rem 1rem !important;
}
.detection-label .right-col .detection-labeled-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.detection-label .right-col .detection-labeled-item {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.5rem 0.65rem;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background var(--transition);
  color: var(--foreground);
}
.detection-label .right-col .detection-labeled-item:hover {
  background: var(--accent);
}
.detection-label .right-col .detection-labeled-item--active {
  background: var(--accent);
  border: 1px solid var(--primary);
}
.detection-label .right-col .detection-labeled-item__name {
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detection-label .right-col .detection-labeled-item__meta {
  font-size: 0.7rem;
  color: var(--muted-foreground);
}
.detection-label .right-col .btn {
  color: var(--foreground) !important;
  border: 1px solid var(--border);
  background: var(--secondary);
}
.detection-label .right-col .btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--ring);
}
.detection-label .right-col .btn:hover {
  background: var(--accent);
  border-color: var(--primary);
}
.detection-label .right-col .btn-secondary {
  background: var(--secondary);
  border-color: var(--border);
  color: var(--secondary-foreground);
}
.detection-label .right-col .btn-secondary:hover {
  background: var(--accent);
  border-color: var(--primary);
}
@media (max-width: 768px) {
  .detection-label .row {
    flex-direction: column;
    height: auto;
  }
  .detection-label .center-col {
    flex: unset;
  }
  .detection-label .center-col .content-top,
  .detection-label .center-col .content-bottom {
    flex: unset;
    max-height: none;
  }
}

/* Left panel – professional image list */
.detection-label .left-col .detection-left-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.detection-upload-zone {
  flex-shrink: 0;
  text-align: center;
  padding: 1rem;
  border: 2px dashed var(--border);
  border-radius: var(--radius);
  background: var(--muted);
  transition: border-color var(--transition), background var(--transition);
}

.detection-upload-zone:hover,
.detection-upload-zone.drag-over {
  border-color: var(--primary);
  background: var(--accent);
}

.detection-upload-hint {
  margin: 0.5rem 0 0;
  font-size: 0.8rem;
  color: var(--muted-foreground);
}

.detection-image-list-section {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.detection-image-list-header {
  flex-shrink: 0;
  margin: 0 0 0.75rem 0;
  padding: 0 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted-foreground);
  border-bottom: 1px solid var(--border);
}

.detection-image-list-ul {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.detection-image-item {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding: 0.35rem 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--card);
  cursor: pointer;
  transition: background var(--transition), border-color var(--transition);
}

.detection-image-item:hover {
  background: var(--accent);
  border-color: var(--primary);
}

.detection-image-item--selected {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--primary-foreground) !important;
}

.detection-image-item__name {
  font-size: 0.72rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detection-image-item__meta {
  font-size: 0.65rem;
  opacity: 0.85;
}

.detection-image-item--selected .detection-image-item__meta {
  opacity: 0.95;
}

.detection-image-list-empty,
.detection-labeled-empty {
  padding: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: var(--muted-foreground);
}

/* Selection controls */
.detection-label .selection-controls {
  padding: 0.5rem 1rem;
  background: var(--muted);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: var(--radius-sm);
}

.detection-label .selection-controls button {
  padding: 0.25rem 0.5rem;
  background: var(--secondary);
  color: var(--secondary-foreground);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 0.8rem;
}

.detection-label .selection-controls button:hover:not(:disabled) {
  background: var(--accent);
  border-color: var(--primary);
}

.detection-label .selection-controls .delete-button {
  background: var(--destructive);
  color: var(--destructive-foreground);
  border-color: var(--destructive);
}

/* Upload button in left panel */
.detection-upload-zone .upload-button {
  background: var(--primary);
  color: var(--primary-foreground);
  border: none;
  padding: 0.5rem 1rem;
  border-radius: var(--radius-sm);
  font-weight: 600;
}

.detection-upload-zone .upload-button:hover {
  background: var(--primary-hover);
}

.detection-label .text-primary {
  color: var(--primary) !important;
}

/* Instructions */
.detection-label .instructions {
  background: var(--muted);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--foreground);
}

/* Initial / empty state */
.detection-label .initial-overlay {
  background: var(--card);
  border: 2px dashed var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  padding: 2rem;
  text-align: center;
  transition: border-color var(--transition), background var(--transition);
}

.detection-label .initial-overlay:hover {
  border-color: var(--primary);
  background: var(--accent);
}

.detection-label .initial-overlay h2 {
  color: var(--muted-foreground);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
}

.detection-label .no-selection,
.detection-label .no-classes {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: var(--muted-foreground);
  text-align: center;
}

.detection-label .no-classes p {
  margin: 0;
  font-size: 0.95rem;
}

/* Upload progress */
.detection-label .upload-progress-overlay {
  background: var(--overlay);
}

.detection-label .upload-progress-container {
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  color: var(--foreground);
}

.detection-label .progress-bar {
  background: var(--muted);
}

.detection-label .progress-fill {
  background: var(--primary);
}

/* Image item, selection badge, etc. */
.detection-label .image-item.multi-selected {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--ring);
}

.detection-label .selection-badge {
  background: var(--primary);
  color: var(--primary-foreground);
}

.detection-label .delete-image-btn {
  background: var(--destructive);
  color: var(--destructive-foreground);
}

.detection-label .class-button.bulk {
  background: var(--primary);
  color: var(--primary-foreground);
}

.detection-label .selection-box {
  border-color: var(--primary);
  background: var(--primary-soft);
}

/* AddClassPopup modal – full theme integration */
.detection-label .add-class-modal .modal-content,
.add-class-modal .modal-content {
  background: var(--card) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}

.detection-label .add-class-modal .modal-header,
.add-class-modal .modal-header {
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%) !important;
  color: var(--primary-foreground) !important;
  border-bottom: none !important;
  border-radius: var(--radius) var(--radius) 0 0;
  padding: 1rem 1.25rem;
}

.detection-label .add-class-modal .modal-header .modal-title,
.add-class-modal .modal-header .modal-title {
  color: var(--primary-foreground) !important;
  font-weight: 600;
}

.detection-label .add-class-modal .modal-header .close,
.add-class-modal .modal-header .close {
  color: var(--primary-foreground) !important;
  opacity: 0.9;
}

.detection-label .add-class-modal .modal-header .close:hover,
.add-class-modal .modal-header .close:hover {
  opacity: 1;
}

.detection-label .add-class-modal .modal-body,
.add-class-modal .modal-body {
  background: var(--card) !important;
  color: var(--foreground) !important;
  padding: 1.25rem;
}

.detection-label .add-class-modal .modal-body .form-control,
.add-class-modal .modal-body .form-control {
  background: var(--card) !important;
  color: var(--foreground) !important;
  border: 1px solid var(--input);
  border-radius: var(--radius-sm);
  padding: 0.5rem 0.75rem;
}

.detection-label .add-class-modal .modal-body .form-control:focus,
.add-class-modal .modal-body .form-control:focus {
  border-color: var(--ring);
  box-shadow: 0 0 0 3px var(--ring);
  outline: none;
}

.detection-label .add-class-modal .modal-body .form-control::placeholder,
.add-class-modal .modal-body .form-control::placeholder {
  color: var(--muted-foreground);
}

.detection-label .add-class-modal .modal-body .col-form-label,
.add-class-modal .modal-body .col-form-label,
.detection-label .add-class-modal .modal-body label,
.add-class-modal .modal-body label {
  color: var(--foreground) !important;
  font-weight: 600;
}

/* Color palette – swatch grid */
.color-palette-group {
  margin-top: 1rem;
}

.color-palette-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.color-palette-current {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 2px solid var(--border);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color var(--transition), transform var(--transition-fast);
}

.color-palette-current:hover {
  border-color: var(--primary);
  transform: scale(1.05);
}

.color-palette-swatches {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 0.35rem;
  flex: 1 1;
}

.color-palette-swatch {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  transition: border-color var(--transition), transform var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.75rem;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
}

.color-palette-swatch:hover {
  transform: scale(1.1);
}

.color-palette-swatch--selected {
  border-color: var(--foreground) !important;
  box-shadow: 0 0 0 2px var(--card);
}

.color-palette-custom-btn {
  margin-top: 0.5rem;
  padding: 0.35rem 0.65rem;
  font-size: 0.8rem;
  background: var(--secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--foreground);
  cursor: pointer;
}

.color-palette-custom-btn:hover {
  background: var(--accent);
  border-color: var(--primary);
}

.color-div {
  margin-top: 1rem;
}

.detection-label .add-class-modal .modal-footer,
.add-class-modal .modal-footer {
  background: var(--muted) !important;
  border-top: 1px solid var(--border);
  border-radius: 0 0 var(--radius) var(--radius);
  padding: 1rem 1.25rem;
}

.detection-label .add-class-modal .modal-footer .btn-primary,
.add-class-modal .modal-footer .btn-primary {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--primary-foreground) !important;
}

.detection-label .add-class-modal .modal-footer .btn-primary:hover,
.add-class-modal .modal-footer .btn-primary:hover {
  background: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.detection-label .add-class-modal .modal-footer .btn-secondary,
.add-class-modal .modal-footer .btn-secondary {
  background: var(--secondary) !important;
  border-color: var(--border) !important;
  color: var(--secondary-foreground) !important;
}

/* ===== AI Auto Label panel ===== */
.detection-label .center-col .content-bottom {
  position: relative;
}

.auto-label-panel {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 30;
  /* Bounded by the canvas it floats over, not by the viewport. It used to be a
     fixed 270px box with no height limit whose body capped itself at
     \`calc(100vh - 16rem)\` — a guess about space the panel does not own. The
     canvas area is far shorter than the viewport (header, page gutter and the
     toolbar all come out of it first), so the panel ran past the bottom edge
     and \`.content-bottom { overflow: hidden }\` cut it off — taking the Detect
     buttons with it, with no scrollbar to say anything was missing. */
  width: min(270px, calc(100% - 2.5rem));
  max-height: calc(100% - 2.5rem);
  display: flex;
  flex-direction: column;
  background: var(--card, #fff);
  color: var(--foreground, #111);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.auto-label-panel__header {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0.85rem;
  background: var(--primary);
  color: var(--primary-foreground);
}

.auto-label-panel__title {
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.auto-label-panel__close {
  background: transparent;
  border: none;
  color: var(--primary-foreground);
  cursor: pointer;
  padding: 0 0.2rem;
  line-height: 1;
}

.auto-label-panel__close:hover {
  opacity: 0.8;
}

.auto-label-panel__body {
  padding: 0.75rem 0.85rem;
}

.auto-label-panel__label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.auto-label-panel__select {
  font-size: 0.82rem;
}

.auto-label-panel__hint {
  display: block;
  font-size: 0.72rem;
  color: var(--muted-foreground);
  margin-top: 0.2rem;
}

/* The chosen mode cannot run as described and something else will happen —
   said in the warning colour, because a hint that reads like every other hint
   is how the silent Smart-mode fallback stayed invisible. */
.auto-label-panel__hint--warn {
  color: var(--warning);
}

.auto-label-panel__switch {
  margin: 0.5rem 0 0.75rem;
  font-size: 0.8rem;
}

.auto-label-panel__actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}

.auto-label-panel__progress {
  margin-top: 0.25rem;
}

.auto-label-panel__review {
  margin-top: 0.75rem;
  padding-top: 0.6rem;
  border-top: 1px dashed var(--border);
}

.auto-label-panel__review-count {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--primary);
}

/* ===== AI Auto Label — thresholds, master image ===== */
/* Takes whatever height the panel has left and scrolls inside it. No
   max-height: the panel's own \`max-height\` is the real limit, and a second
   guess here is what let the two disagree. */
.auto-label-panel__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* Detect / Detect all / Stop / Accept / Discard — pinned, so the control you
   came here to press is never the thing scrolled out of view. */
.auto-label-panel__footer {
  flex: 0 0 auto;
  padding: 0.6rem 0.85rem;
  border-top: 1px solid var(--border);
  background: var(--card);
}

/* It carries the footer's own border now, so it does not need a second one. */
.auto-label-panel__footer .auto-label-panel__review {
  margin-top: 0.6rem;
}

.auto-label-panel__threshold {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.auto-label-panel__threshold .form-range {
  flex: 1 1 auto;
  min-width: 0;
}

.auto-label-panel__number {
  flex: 0 0 4.25rem;
  width: 4.25rem;
  font-size: 0.78rem;
  padding: 0.15rem 0.35rem;
  text-align: center;
}

.auto-label-panel__master {
  margin-top: 0.75rem;
  padding-top: 0.6rem;
  border-top: 1px dashed var(--border);
}

.auto-label-panel__master-info {
  margin-top: 0.4rem;
  padding: 0.45rem 0.5rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--muted);
}

.auto-label-panel__master-name {
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
  color: var(--foreground);
}

.auto-label-panel__master .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
}

/* MASTER marker in the image list */
.detection-image-item__master {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: 0.35rem;
  padding: 0 0.3rem;
  border-radius: 4px;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  background: var(--primary);
  color: var(--primary-foreground);
  flex: 0 0 auto;
}

/* =====================================================================
   Canvas stage
   The viewport fills the panel; the image is fitted into it by
   useCanvasViewport, so a 96px image and a 6000px image both fill the space.
   ===================================================================== */
.detection-label .lf-canvas-stage {
  --lf-statusbar-h: 30px;
  position: relative;
  flex: 1 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  border-radius: var(--radius);
}

.detection-label .lf-canvas-viewport {
  position: absolute;
  inset: 0 0 var(--lf-statusbar-h) 0;
  overflow: hidden;
  touch-action: none; /* wheel/pointer are handled by the viewport hook */
}

.detection-label .lf-canvas-viewport[data-empty=true] {
  opacity: 0;
  pointer-events: none;
}

/* fabric owns the tool cursors; these two are ours (space / middle-drag pan) */
.detection-label .lf-canvas-viewport[data-cursor=grab] canvas {
  cursor: grab !important;
}

.detection-label .lf-canvas-viewport[data-cursor=panning] canvas {
  cursor: grabbing !important;
}

.detection-label .lf-canvas-chip {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  z-index: 5;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  max-width: calc(100% - 1.2rem);
  padding: 0.3rem 0.7rem;
  border-radius: var(--radius-full);
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  font-size: 0.75rem;
  color: var(--foreground);
}

.detection-label .lf-canvas-chip i {
  color: var(--muted-foreground);
}

.detection-label .lf-canvas-chip__name {
  max-width: 26ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.detection-label .lf-canvas-chip__index {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--muted-foreground);
  padding-left: 0.45rem;
  border-left: 1px solid var(--border);
}

.detection-label .lf-canvas-statusbar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: var(--lf-statusbar-h);
  z-index: 5;
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 0.75rem;
  background: var(--card);
  border-top: 1px solid var(--border);
  font-size: 0.72rem;
  color: var(--muted-foreground);
  overflow: hidden;
}

.detection-label .lf-canvas-stat {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.detection-label .lf-canvas-stat i {
  opacity: 0.7;
}

.detection-label .lf-canvas-stat--coords {
  font-family: var(--font-mono);
  min-width: 8rem;
}

.detection-label .lf-canvas-stat--hint {
  margin-left: auto;
  opacity: 0.75;
}

.detection-label .lf-canvas-hint {
  position: absolute;
  left: 50%;
  bottom: calc(var(--lf-statusbar-h) + 0.6rem);
  transform: translateX(-50%);
  z-index: 6;
  pointer-events: none;
  max-width: calc(100% - 2rem);
  padding: 0.4rem 0.85rem;
  border-radius: var(--radius-full);
  background: var(--primary);
  color: var(--primary-foreground);
  font-size: 0.75rem;
  font-weight: 500;
  box-shadow: var(--shadow-md);
}

.detection-label .lf-canvas-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.detection-label .lf-canvas-empty .initial-overlay {
  max-width: 320px;
}

.detection-label .lf-canvas-empty .initial-overlay i {
  display: block;
  margin-bottom: 0.75rem;
  font-size: 3rem;
  color: var(--muted-foreground);
}

.detection-label .lf-canvas-empty .initial-overlay p {
  margin: 0;
  color: var(--muted-foreground);
  font-size: 0.9rem;
}

/* --- hide the wordier status text before the bar starts to crowd --------- */
@media (max-width: 1400px) {
  .detection-label .lf-canvas-stat--hint {
    display: none;
  }
}
/* --- stacked layout: canvas first, panels below --------------------- */
@media (max-width: 992px) {
  .detection-label {
    height: auto;
    min-height: 0;
    overflow: visible;
  }
  .detection-label .main-content {
    flex-wrap: wrap;
    overflow: visible;
  }
  .detection-label .main-content > .center-col {
    flex: 1 1 100%;
    order: -1;
    min-height: 60vh;
  }
  .detection-label .main-content > .left-col,
  .detection-label .main-content > .right-col {
    flex: 1 1 100%;
    max-height: 45vh;
    overflow-y: auto;
  }
  .detection-label .lf-canvas-stat--coords {
    display: none;
  }
}
/* =====================================================================
   "You need a class first" affordance
   Replaces the modal alert that used to fire on every attempt to draw:
   a persistent callout on the canvas plus a short highlight on the panel
   the user has to act in.
   ===================================================================== */
.detection-label .lf-canvas-callout {
  position: absolute;
  left: 50%;
  bottom: calc(var(--lf-statusbar-h) + 0.75rem);
  transform: translateX(-50%);
  z-index: 6;
  pointer-events: auto; /* the action button has to be clickable */
  display: flex;
  align-items: center;
  gap: 0.85rem;
  max-width: calc(100% - 2rem);
  padding: 0.6rem 0.75rem 0.6rem 0.9rem;
  border-radius: var(--radius);
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  transition: border-color var(--transition), box-shadow var(--transition);
}

/* react-tippy wraps the Button atom in a div — keep it out of the layout */
.detection-label .lf-canvas-callout > div {
  display: flex;
  flex-shrink: 0;
}

.detection-label .lf-canvas-callout > i {
  font-size: 1.1rem;
  color: var(--primary);
}

.detection-label .lf-canvas-callout__text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  font-size: 0.75rem;
  color: var(--muted-foreground);
  line-height: 1.35;
}

.detection-label .lf-canvas-callout__text strong {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--foreground);
}

.detection-label .lf-canvas-callout__action {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
  height: 32px;
  padding: 0 0.85rem;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--primary);
  color: var(--primary-foreground);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--transition);
}

.detection-label .lf-canvas-callout__action:hover {
  background: var(--primary-hover);
}

/* Nudged: a static ring (which survives prefers-reduced-motion) plus a pulse. */
.detection-label .lf-canvas-callout--nudge {
  border-color: var(--primary);
  box-shadow: var(--shadow-glow);
  animation: lf-attention-pulse 0.6s ease-out 2;
}

.detection-label .lf-attention {
  border-color: var(--primary) !important;
  box-shadow: var(--shadow-glow) !important;
  animation: lf-attention-pulse 0.6s ease-out 2;
}

@keyframes lf-attention-pulse {
  0% {
    transform: scale(1);
  }
  35% {
    transform: scale(1.015);
  }
  100% {
    transform: scale(1);
  }
}
/* the callout is centred by a transform, so it needs its own keyframes */
.detection-label .lf-canvas-callout--nudge {
  animation-name: lf-attention-pulse-centered;
}

@keyframes lf-attention-pulse-centered {
  0% {
    transform: translateX(-50%) scale(1);
  }
  35% {
    transform: translateX(-50%) scale(1.03);
  }
  100% {
    transform: translateX(-50%) scale(1);
  }
}
@media (max-width: 768px) {
  .detection-label .lf-canvas-callout {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
  }
}
/* ===== AI panel — pre-label from a trained version (model-in-the-loop) ===== */
.auto-label-panel__prelabel {
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px dashed var(--border);
}

.auto-label-panel__section-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--foreground);
}

.auto-label-panel__section-title > i {
  color: var(--primary);
}

.auto-label-panel__prelabel .progress {
  background: var(--muted);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.auto-label-panel__prelabel .progress-bar {
  background: var(--primary);
  transition: width var(--transition);
}

.auto-label-panel__error {
  display: block;
  margin-top: 0.5rem;
  padding: 0.4rem 0.5rem;
  border-radius: var(--radius-sm);
  background: var(--warning-soft);
  color: var(--warning);
  font-size: 0.72rem;
  line-height: 1.35;
}
`, "",{"version":3,"sources":["webpack://./src/pages/management/labelManagement/detectionLabel/styles/detectionLabel.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;AACA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;;EAEE,4FAA4F;EAC5F,2CAA2C;EAC3C,8BAA8B;EAC9B,8CAA8C;EAC9C,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;AACA;;EAEE,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gDAAgD;EAChD,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,wGAAwG;EACxG,cAAc;AAChB;AACA;;EAEE,gDAAgD;EAChD,sCAAsC;EACtC,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4FAA4F;EAC5F,2CAA2C;EAC3C,gBAAgB;EAChB,kCAAkC;EAClC,uCAAuC;EACvC,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,iDAAiD;EACjD,8CAA8C;EAC9C,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;EACzC,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,sGAAsG;AACxG;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,qCAAqC;EACrC,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,wCAAwC;EACxC,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,wEAAwE;AAC1E;;AAEA;;EAEE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,wBAAwB;EACxB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD;;EAEE,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;EAEE,4FAA4F;EAC5F,2CAA2C;EAC3C,8BAA8B;EAC9B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;EAEE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;AACf;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;EAIE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;AAC9E;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,4EAA4E;EAC5E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,mCAAmC;EACnC,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;;EAEE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;;EAEE,uCAAuC;EACvC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX;;;;;;sEAMoE;EACpE,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;4DAE4D;AAC5D;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,yDAAyD;AACzD;;6CAE6C;AAC7C;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;gEACgE;AAChE;EACE,cAAc;EACd,uBAAuB;EACvB,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;;;0EAI0E;AAC1E;EACE,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB,EAAE,mDAAmD;AACzE;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,+EAA+E;AAC/E;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,4CAA4C;EAC5C,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,4BAA4B;EAC5B,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,8EAA8E;AAC9E;EACE;IACE,aAAa;EACf;AACF;AACA,yEAAyE;AACzE;EACE;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;EACA;;IAEE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;;;;;0EAK0E;AAC1E;EACE,kBAAkB;EAClB,SAAS;EACT,6CAA6C;EAC7C,2BAA2B;EAC3B,UAAU;EACV,oBAAoB,EAAE,0CAA0C;EAChE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,qCAAqC;EACrC,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,wEAAwE;AAC1E;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gFAAgF;AAChF;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;AACF;AACA,yEAAyE;AACzE;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;AACF;AACA,gFAAgF;AAChF;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["@charset \"UTF-8\";\n.detection-label {\n  background: var(--page-bg);\n  padding: 0.5rem 0;\n  width: 100%;\n  max-width: 100vw;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.detection-label .detection-filter-wrap {\n  flex-shrink: 0;\n  padding: 0 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.detection-label .page-header {\n  height: 44px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n}\n.detection-label .page-header-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  background: var(--card);\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 0.5rem;\n}\n.detection-label .page-header-title h5 {\n  margin: 0;\n  font-weight: 600;\n  font-size: 1.15rem;\n  color: var(--foreground);\n}\n.detection-label .page-header-title .btn-primary {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: var(--primary-foreground);\n}\n.detection-label .page-header-title .btn-primary:hover {\n  background: var(--primary-hover);\n  border-color: var(--primary-hover);\n}\n.detection-label .main-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.75rem;\n  width: 100%;\n  overflow: hidden;\n}\n.detection-label .main-content > .left-col {\n  flex: 0 0 15%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 1rem;\n  overflow: hidden;\n  background: var(--card) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.detection-label .main-content > .right-col {\n  flex: 0 0 15%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 1rem;\n  overflow: hidden;\n  background: var(--card) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.detection-label .right-col {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n.detection-label .center-col {\n  flex: 0 0 70%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  overflow: hidden;\n}\n.detection-label .center-col .content-top {\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0.75rem;\n  overflow-y: auto;\n  background: var(--card) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.detection-label .center-col .content-top .active {\n  background: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n.detection-label .center-col .content-bottom {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background: var(--page-bg-subtle) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.detection-label .right-col > .content-top {\n  flex: 0 1 auto;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  overflow: visible;\n  background: transparent !important;\n  border: none;\n  box-shadow: none;\n}\n.detection-label .right-col > .content-bottom {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: transparent !important;\n  border: none;\n  box-shadow: none;\n}\n.detection-label .right-col .card {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.detection-label .right-col .content-top .card .card-header,\n.detection-label .right-col .card-header-classes {\n  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%) !important;\n  color: var(--primary-foreground) !important;\n  border-bottom: none !important;\n  border-radius: var(--radius) var(--radius) 0 0;\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n.detection-label .right-col .card-header-classes__title,\n.detection-label .right-col .content-top .card .card-header h5 {\n  color: var(--primary-foreground) !important;\n  font-weight: 600;\n  font-size: 1rem;\n  margin: 0;\n  flex-shrink: 0;\n}\n.detection-label .right-col .card-header-classes__actions {\n  margin-left: auto;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n.detection-label .right-col .content-top .card .card-header .btn-add-class,\n.detection-label .right-col .card-header-classes .btn-add-class {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  background: var(--primary-foreground) !important;\n  border: none !important;\n  color: var(--primary) !important;\n  font-weight: 600;\n  font-size: 0.875rem;\n  padding: 0.4rem 0.85rem;\n  border-radius: var(--radius-sm);\n  transition: background var(--transition), transform var(--transition-fast), box-shadow var(--transition);\n  flex-shrink: 0;\n}\n.detection-label .right-col .content-top .card .card-header .btn-add-class:hover,\n.detection-label .right-col .card-header-classes .btn-add-class:hover {\n  background: var(--primary-foreground) !important;\n  color: var(--primary-hover) !important;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n.detection-label {\n  /* Empty state - Add Class button on right */\n}\n.detection-label .right-col .card-body-classes__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 1rem;\n  padding: 2rem 1.5rem;\n  min-height: 140px;\n}\n.detection-label .right-col .card-body-classes__empty-text {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--muted-foreground);\n  margin-right: auto;\n}\n.detection-label .right-col .btn-add-class--centered {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%) !important;\n  color: var(--primary-foreground) !important;\n  font-weight: 600;\n  padding: 0.6rem 1.25rem !important;\n  border-radius: var(--radius) !important;\n  border: none !important;\n  box-shadow: var(--shadow-glow);\n}\n.detection-label .right-col .btn-add-class--centered:hover {\n  background: var(--primary-hover) !important;\n  color: var(--primary-foreground) !important;\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-glow);\n}\n.detection-label .right-col .content-bottom .card .card-header {\n  background: var(--muted) !important;\n  color: var(--foreground) !important;\n  border-bottom: 1px solid var(--border) !important;\n  border-radius: var(--radius) var(--radius) 0 0;\n  padding: 0.75rem 1rem;\n}\n.detection-label .right-col .content-bottom .card .card-header h5 {\n  color: var(--foreground) !important;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n.detection-label .right-col .content-bottom .card .card-header .btn-secondary {\n  background: var(--secondary) !important;\n  border-color: var(--border) !important;\n  color: var(--secondary-foreground) !important;\n  font-size: 0.8rem;\n}\n.detection-label .right-col .card-body {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  padding: 1rem !important;\n}\n.detection-label .right-col .card-body-classes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.detection-label .right-col .detection-class-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.5rem 0.65rem;\n  border-radius: var(--radius-sm);\n  border-left: 4px solid var(--class-color);\n  background: var(--muted);\n  color: var(--foreground);\n  cursor: pointer;\n  transition: background var(--transition), border-color var(--transition), box-shadow var(--transition);\n}\n.detection-label .right-col .detection-class-item:hover {\n  background: var(--accent);\n}\n.detection-label .right-col .detection-class-item--active {\n  background: var(--primary-soft) !important;\n  color: var(--foreground) !important;\n  border-left-color: var(--class-color);\n  box-shadow: inset 0 0 0 1px var(--primary);\n}\n.detection-label .right-col .detection-class-item__swatch {\n  flex-shrink: 0;\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  border: 1px solid var(--border-strong);\n}\n.detection-label .right-col .detection-class-item--active .detection-class-item__swatch {\n  border-color: var(--border-strong);\n}\n.detection-label .right-col .detection-class-item__name {\n  font-weight: 600;\n  font-size: 0.85rem;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.detection-label .right-col .detection-class-item__edit {\n  flex-shrink: 0;\n  padding: 0.25rem 0.4rem !important;\n  background: transparent !important;\n  border: none !important;\n  color: inherit !important;\n  opacity: 0.8;\n}\n.detection-label .right-col .detection-class-item__edit:hover {\n  opacity: 1;\n}\n.detection-label .right-col .detection-class-item--active .detection-class-item__edit:hover {\n  background: var(--accent) !important;\n  border-radius: var(--radius-sm);\n}\n.detection-label .right-col .card-body-labeled {\n  padding: 0.75rem 1rem !important;\n}\n.detection-label .right-col .detection-labeled-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n.detection-label .right-col .detection-labeled-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding: 0.5rem 0.65rem;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: background var(--transition);\n  color: var(--foreground);\n}\n.detection-label .right-col .detection-labeled-item:hover {\n  background: var(--accent);\n}\n.detection-label .right-col .detection-labeled-item--active {\n  background: var(--accent);\n  border: 1px solid var(--primary);\n}\n.detection-label .right-col .detection-labeled-item__name {\n  font-size: 0.8rem;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.detection-label .right-col .detection-labeled-item__meta {\n  font-size: 0.7rem;\n  color: var(--muted-foreground);\n}\n.detection-label .right-col .btn {\n  color: var(--foreground) !important;\n  border: 1px solid var(--border);\n  background: var(--secondary);\n}\n.detection-label .right-col .btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--ring);\n}\n.detection-label .right-col .btn:hover {\n  background: var(--accent);\n  border-color: var(--primary);\n}\n.detection-label .right-col .btn-secondary {\n  background: var(--secondary);\n  border-color: var(--border);\n  color: var(--secondary-foreground);\n}\n.detection-label .right-col .btn-secondary:hover {\n  background: var(--accent);\n  border-color: var(--primary);\n}\n@media (max-width: 768px) {\n  .detection-label .row {\n    flex-direction: column;\n    height: auto;\n  }\n  .detection-label .center-col {\n    flex: unset;\n  }\n  .detection-label .center-col .content-top,\n  .detection-label .center-col .content-bottom {\n    flex: unset;\n    max-height: none;\n  }\n}\n\n/* Left panel – professional image list */\n.detection-label .left-col .detection-left-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.detection-upload-zone {\n  flex-shrink: 0;\n  text-align: center;\n  padding: 1rem;\n  border: 2px dashed var(--border);\n  border-radius: var(--radius);\n  background: var(--muted);\n  transition: border-color var(--transition), background var(--transition);\n}\n\n.detection-upload-zone:hover,\n.detection-upload-zone.drag-over {\n  border-color: var(--primary);\n  background: var(--accent);\n}\n\n.detection-upload-hint {\n  margin: 0.5rem 0 0;\n  font-size: 0.8rem;\n  color: var(--muted-foreground);\n}\n\n.detection-image-list-section {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.detection-image-list-header {\n  flex-shrink: 0;\n  margin: 0 0 0.75rem 0;\n  padding: 0 0 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--muted-foreground);\n  border-bottom: 1px solid var(--border);\n}\n\n.detection-image-list-ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.detection-image-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  padding: 0.35rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  background: var(--card);\n  cursor: pointer;\n  transition: background var(--transition), border-color var(--transition);\n}\n\n.detection-image-item:hover {\n  background: var(--accent);\n  border-color: var(--primary);\n}\n\n.detection-image-item--selected {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n\n.detection-image-item__name {\n  font-size: 0.72rem;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.detection-image-item__meta {\n  font-size: 0.65rem;\n  opacity: 0.85;\n}\n\n.detection-image-item--selected .detection-image-item__meta {\n  opacity: 0.95;\n}\n\n.detection-image-list-empty,\n.detection-labeled-empty {\n  padding: 1.5rem;\n  text-align: center;\n  font-size: 0.875rem;\n  color: var(--muted-foreground);\n}\n\n/* Selection controls */\n.detection-label .selection-controls {\n  padding: 0.5rem 1rem;\n  background: var(--muted);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  border-radius: var(--radius-sm);\n}\n\n.detection-label .selection-controls button {\n  padding: 0.25rem 0.5rem;\n  background: var(--secondary);\n  color: var(--secondary-foreground);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.detection-label .selection-controls button:hover:not(:disabled) {\n  background: var(--accent);\n  border-color: var(--primary);\n}\n\n.detection-label .selection-controls .delete-button {\n  background: var(--destructive);\n  color: var(--destructive-foreground);\n  border-color: var(--destructive);\n}\n\n/* Upload button in left panel */\n.detection-upload-zone .upload-button {\n  background: var(--primary);\n  color: var(--primary-foreground);\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n}\n\n.detection-upload-zone .upload-button:hover {\n  background: var(--primary-hover);\n}\n\n.detection-label .text-primary {\n  color: var(--primary) !important;\n}\n\n/* Instructions */\n.detection-label .instructions {\n  background: var(--muted);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--foreground);\n}\n\n/* Initial / empty state */\n.detection-label .initial-overlay {\n  background: var(--card);\n  border: 2px dashed var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n  padding: 2rem;\n  text-align: center;\n  transition: border-color var(--transition), background var(--transition);\n}\n\n.detection-label .initial-overlay:hover {\n  border-color: var(--primary);\n  background: var(--accent);\n}\n\n.detection-label .initial-overlay h2 {\n  color: var(--muted-foreground);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 0.75rem 0;\n}\n\n.detection-label .no-selection,\n.detection-label .no-classes {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  color: var(--muted-foreground);\n  text-align: center;\n}\n\n.detection-label .no-classes p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n/* Upload progress */\n.detection-label .upload-progress-overlay {\n  background: var(--overlay);\n}\n\n.detection-label .upload-progress-container {\n  background: var(--card);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-lg);\n  color: var(--foreground);\n}\n\n.detection-label .progress-bar {\n  background: var(--muted);\n}\n\n.detection-label .progress-fill {\n  background: var(--primary);\n}\n\n/* Image item, selection badge, etc. */\n.detection-label .image-item.multi-selected {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--ring);\n}\n\n.detection-label .selection-badge {\n  background: var(--primary);\n  color: var(--primary-foreground);\n}\n\n.detection-label .delete-image-btn {\n  background: var(--destructive);\n  color: var(--destructive-foreground);\n}\n\n.detection-label .class-button.bulk {\n  background: var(--primary);\n  color: var(--primary-foreground);\n}\n\n.detection-label .selection-box {\n  border-color: var(--primary);\n  background: var(--primary-soft);\n}\n\n/* AddClassPopup modal – full theme integration */\n.detection-label .add-class-modal .modal-content,\n.add-class-modal .modal-content {\n  background: var(--card) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n}\n\n.detection-label .add-class-modal .modal-header,\n.add-class-modal .modal-header {\n  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%) !important;\n  color: var(--primary-foreground) !important;\n  border-bottom: none !important;\n  border-radius: var(--radius) var(--radius) 0 0;\n  padding: 1rem 1.25rem;\n}\n\n.detection-label .add-class-modal .modal-header .modal-title,\n.add-class-modal .modal-header .modal-title {\n  color: var(--primary-foreground) !important;\n  font-weight: 600;\n}\n\n.detection-label .add-class-modal .modal-header .close,\n.add-class-modal .modal-header .close {\n  color: var(--primary-foreground) !important;\n  opacity: 0.9;\n}\n\n.detection-label .add-class-modal .modal-header .close:hover,\n.add-class-modal .modal-header .close:hover {\n  opacity: 1;\n}\n\n.detection-label .add-class-modal .modal-body,\n.add-class-modal .modal-body {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  padding: 1.25rem;\n}\n\n.detection-label .add-class-modal .modal-body .form-control,\n.add-class-modal .modal-body .form-control {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  border: 1px solid var(--input);\n  border-radius: var(--radius-sm);\n  padding: 0.5rem 0.75rem;\n}\n\n.detection-label .add-class-modal .modal-body .form-control:focus,\n.add-class-modal .modal-body .form-control:focus {\n  border-color: var(--ring);\n  box-shadow: 0 0 0 3px var(--ring);\n  outline: none;\n}\n\n.detection-label .add-class-modal .modal-body .form-control::placeholder,\n.add-class-modal .modal-body .form-control::placeholder {\n  color: var(--muted-foreground);\n}\n\n.detection-label .add-class-modal .modal-body .col-form-label,\n.add-class-modal .modal-body .col-form-label,\n.detection-label .add-class-modal .modal-body label,\n.add-class-modal .modal-body label {\n  color: var(--foreground) !important;\n  font-weight: 600;\n}\n\n/* Color palette – swatch grid */\n.color-palette-group {\n  margin-top: 1rem;\n}\n\n.color-palette-wrapper {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.color-palette-current {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  border: 2px solid var(--border);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color var(--transition), transform var(--transition-fast);\n}\n\n.color-palette-current:hover {\n  border-color: var(--primary);\n  transform: scale(1.05);\n}\n\n.color-palette-swatches {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 0.35rem;\n  flex: 1;\n}\n\n.color-palette-swatch {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  padding: 0;\n  transition: border-color var(--transition), transform var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 0.75rem;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);\n}\n\n.color-palette-swatch:hover {\n  transform: scale(1.1);\n}\n\n.color-palette-swatch--selected {\n  border-color: var(--foreground) !important;\n  box-shadow: 0 0 0 2px var(--card);\n}\n\n.color-palette-custom-btn {\n  margin-top: 0.5rem;\n  padding: 0.35rem 0.65rem;\n  font-size: 0.8rem;\n  background: var(--secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--foreground);\n  cursor: pointer;\n}\n\n.color-palette-custom-btn:hover {\n  background: var(--accent);\n  border-color: var(--primary);\n}\n\n.color-div {\n  margin-top: 1rem;\n}\n\n.detection-label .add-class-modal .modal-footer,\n.add-class-modal .modal-footer {\n  background: var(--muted) !important;\n  border-top: 1px solid var(--border);\n  border-radius: 0 0 var(--radius) var(--radius);\n  padding: 1rem 1.25rem;\n}\n\n.detection-label .add-class-modal .modal-footer .btn-primary,\n.add-class-modal .modal-footer .btn-primary {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n\n.detection-label .add-class-modal .modal-footer .btn-primary:hover,\n.add-class-modal .modal-footer .btn-primary:hover {\n  background: var(--primary-hover) !important;\n  border-color: var(--primary-hover) !important;\n}\n\n.detection-label .add-class-modal .modal-footer .btn-secondary,\n.add-class-modal .modal-footer .btn-secondary {\n  background: var(--secondary) !important;\n  border-color: var(--border) !important;\n  color: var(--secondary-foreground) !important;\n}\n\n/* ===== AI Auto Label panel ===== */\n.detection-label .center-col .content-bottom {\n  position: relative;\n}\n\n.auto-label-panel {\n  position: absolute;\n  top: 1.25rem;\n  right: 1.25rem;\n  z-index: 30;\n  /* Bounded by the canvas it floats over, not by the viewport. It used to be a\n     fixed 270px box with no height limit whose body capped itself at\n     `calc(100vh - 16rem)` — a guess about space the panel does not own. The\n     canvas area is far shorter than the viewport (header, page gutter and the\n     toolbar all come out of it first), so the panel ran past the bottom edge\n     and `.content-bottom { overflow: hidden }` cut it off — taking the Detect\n     buttons with it, with no scrollbar to say anything was missing. */\n  width: min(270px, calc(100% - 2.5rem));\n  max-height: calc(100% - 2.5rem);\n  display: flex;\n  flex-direction: column;\n  background: var(--card, #fff);\n  color: var(--foreground, #111);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.auto-label-panel__header {\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.6rem 0.85rem;\n  background: var(--primary);\n  color: var(--primary-foreground);\n}\n\n.auto-label-panel__title {\n  font-weight: 600;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.auto-label-panel__close {\n  background: transparent;\n  border: none;\n  color: var(--primary-foreground);\n  cursor: pointer;\n  padding: 0 0.2rem;\n  line-height: 1;\n}\n\n.auto-label-panel__close:hover {\n  opacity: 0.8;\n}\n\n.auto-label-panel__body {\n  padding: 0.75rem 0.85rem;\n}\n\n.auto-label-panel__label {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.auto-label-panel__select {\n  font-size: 0.82rem;\n}\n\n.auto-label-panel__hint {\n  display: block;\n  font-size: 0.72rem;\n  color: var(--muted-foreground);\n  margin-top: 0.2rem;\n}\n\n/* The chosen mode cannot run as described and something else will happen —\n   said in the warning colour, because a hint that reads like every other hint\n   is how the silent Smart-mode fallback stayed invisible. */\n.auto-label-panel__hint--warn {\n  color: var(--warning);\n}\n\n.auto-label-panel__switch {\n  margin: 0.5rem 0 0.75rem;\n  font-size: 0.8rem;\n}\n\n.auto-label-panel__actions .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n}\n\n.auto-label-panel__progress {\n  margin-top: 0.25rem;\n}\n\n.auto-label-panel__review {\n  margin-top: 0.75rem;\n  padding-top: 0.6rem;\n  border-top: 1px dashed var(--border);\n}\n\n.auto-label-panel__review-count {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n/* ===== AI Auto Label — thresholds, master image ===== */\n/* Takes whatever height the panel has left and scrolls inside it. No\n   max-height: the panel's own `max-height` is the real limit, and a second\n   guess here is what let the two disagree. */\n.auto-label-panel__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n/* Detect / Detect all / Stop / Accept / Discard — pinned, so the control you\n   came here to press is never the thing scrolled out of view. */\n.auto-label-panel__footer {\n  flex: 0 0 auto;\n  padding: 0.6rem 0.85rem;\n  border-top: 1px solid var(--border);\n  background: var(--card);\n}\n\n/* It carries the footer's own border now, so it does not need a second one. */\n.auto-label-panel__footer .auto-label-panel__review {\n  margin-top: 0.6rem;\n}\n\n.auto-label-panel__threshold {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.auto-label-panel__threshold .form-range {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.auto-label-panel__number {\n  flex: 0 0 4.25rem;\n  width: 4.25rem;\n  font-size: 0.78rem;\n  padding: 0.15rem 0.35rem;\n  text-align: center;\n}\n\n.auto-label-panel__master {\n  margin-top: 0.75rem;\n  padding-top: 0.6rem;\n  border-top: 1px dashed var(--border);\n}\n\n.auto-label-panel__master-info {\n  margin-top: 0.4rem;\n  padding: 0.45rem 0.5rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--muted);\n}\n\n.auto-label-panel__master-name {\n  font-size: 0.78rem;\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n  color: var(--foreground);\n}\n\n.auto-label-panel__master .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n}\n\n/* MASTER marker in the image list */\n.detection-image-item__master {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-left: 0.35rem;\n  padding: 0 0.3rem;\n  border-radius: 4px;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  background: var(--primary);\n  color: var(--primary-foreground);\n  flex: 0 0 auto;\n}\n\n/* =====================================================================\n   Canvas stage\n   The viewport fills the panel; the image is fitted into it by\n   useCanvasViewport, so a 96px image and a 6000px image both fill the space.\n   ===================================================================== */\n.detection-label .lf-canvas-stage {\n  --lf-statusbar-h: 30px;\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n  border-radius: var(--radius);\n}\n\n.detection-label .lf-canvas-viewport {\n  position: absolute;\n  inset: 0 0 var(--lf-statusbar-h) 0;\n  overflow: hidden;\n  touch-action: none; /* wheel/pointer are handled by the viewport hook */\n}\n\n.detection-label .lf-canvas-viewport[data-empty=true] {\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* fabric owns the tool cursors; these two are ours (space / middle-drag pan) */\n.detection-label .lf-canvas-viewport[data-cursor=grab] canvas {\n  cursor: grab !important;\n}\n\n.detection-label .lf-canvas-viewport[data-cursor=panning] canvas {\n  cursor: grabbing !important;\n}\n\n.detection-label .lf-canvas-chip {\n  position: absolute;\n  top: 0.6rem;\n  left: 0.6rem;\n  z-index: 5;\n  pointer-events: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  max-width: calc(100% - 1.2rem);\n  padding: 0.3rem 0.7rem;\n  border-radius: var(--radius-full);\n  background: var(--card);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  font-size: 0.75rem;\n  color: var(--foreground);\n}\n\n.detection-label .lf-canvas-chip i {\n  color: var(--muted-foreground);\n}\n\n.detection-label .lf-canvas-chip__name {\n  max-width: 26ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.detection-label .lf-canvas-chip__index {\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  color: var(--muted-foreground);\n  padding-left: 0.45rem;\n  border-left: 1px solid var(--border);\n}\n\n.detection-label .lf-canvas-statusbar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: var(--lf-statusbar-h);\n  z-index: 5;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0 0.75rem;\n  background: var(--card);\n  border-top: 1px solid var(--border);\n  font-size: 0.72rem;\n  color: var(--muted-foreground);\n  overflow: hidden;\n}\n\n.detection-label .lf-canvas-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.detection-label .lf-canvas-stat i {\n  opacity: 0.7;\n}\n\n.detection-label .lf-canvas-stat--coords {\n  font-family: var(--font-mono);\n  min-width: 8rem;\n}\n\n.detection-label .lf-canvas-stat--hint {\n  margin-left: auto;\n  opacity: 0.75;\n}\n\n.detection-label .lf-canvas-hint {\n  position: absolute;\n  left: 50%;\n  bottom: calc(var(--lf-statusbar-h) + 0.6rem);\n  transform: translateX(-50%);\n  z-index: 6;\n  pointer-events: none;\n  max-width: calc(100% - 2rem);\n  padding: 0.4rem 0.85rem;\n  border-radius: var(--radius-full);\n  background: var(--primary);\n  color: var(--primary-foreground);\n  font-size: 0.75rem;\n  font-weight: 500;\n  box-shadow: var(--shadow-md);\n}\n\n.detection-label .lf-canvas-empty {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.detection-label .lf-canvas-empty .initial-overlay {\n  max-width: 320px;\n}\n\n.detection-label .lf-canvas-empty .initial-overlay i {\n  display: block;\n  margin-bottom: 0.75rem;\n  font-size: 3rem;\n  color: var(--muted-foreground);\n}\n\n.detection-label .lf-canvas-empty .initial-overlay p {\n  margin: 0;\n  color: var(--muted-foreground);\n  font-size: 0.9rem;\n}\n\n/* --- hide the wordier status text before the bar starts to crowd --------- */\n@media (max-width: 1400px) {\n  .detection-label .lf-canvas-stat--hint {\n    display: none;\n  }\n}\n/* --- stacked layout: canvas first, panels below --------------------- */\n@media (max-width: 992px) {\n  .detection-label {\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n  .detection-label .main-content {\n    flex-wrap: wrap;\n    overflow: visible;\n  }\n  .detection-label .main-content > .center-col {\n    flex: 1 1 100%;\n    order: -1;\n    min-height: 60vh;\n  }\n  .detection-label .main-content > .left-col,\n  .detection-label .main-content > .right-col {\n    flex: 1 1 100%;\n    max-height: 45vh;\n    overflow-y: auto;\n  }\n  .detection-label .lf-canvas-stat--coords {\n    display: none;\n  }\n}\n/* =====================================================================\n   \"You need a class first\" affordance\n   Replaces the modal alert that used to fire on every attempt to draw:\n   a persistent callout on the canvas plus a short highlight on the panel\n   the user has to act in.\n   ===================================================================== */\n.detection-label .lf-canvas-callout {\n  position: absolute;\n  left: 50%;\n  bottom: calc(var(--lf-statusbar-h) + 0.75rem);\n  transform: translateX(-50%);\n  z-index: 6;\n  pointer-events: auto; /* the action button has to be clickable */\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  max-width: calc(100% - 2rem);\n  padding: 0.6rem 0.75rem 0.6rem 0.9rem;\n  border-radius: var(--radius);\n  background: var(--card);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-lg);\n  transition: border-color var(--transition), box-shadow var(--transition);\n}\n\n/* react-tippy wraps the Button atom in a div — keep it out of the layout */\n.detection-label .lf-canvas-callout > div {\n  display: flex;\n  flex-shrink: 0;\n}\n\n.detection-label .lf-canvas-callout > i {\n  font-size: 1.1rem;\n  color: var(--primary);\n}\n\n.detection-label .lf-canvas-callout__text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  font-size: 0.75rem;\n  color: var(--muted-foreground);\n  line-height: 1.35;\n}\n\n.detection-label .lf-canvas-callout__text strong {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--foreground);\n}\n\n.detection-label .lf-canvas-callout__action {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n  height: 32px;\n  padding: 0 0.85rem;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: var(--primary);\n  color: var(--primary-foreground);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background var(--transition);\n}\n\n.detection-label .lf-canvas-callout__action:hover {\n  background: var(--primary-hover);\n}\n\n/* Nudged: a static ring (which survives prefers-reduced-motion) plus a pulse. */\n.detection-label .lf-canvas-callout--nudge {\n  border-color: var(--primary);\n  box-shadow: var(--shadow-glow);\n  animation: lf-attention-pulse 0.6s ease-out 2;\n}\n\n.detection-label .lf-attention {\n  border-color: var(--primary) !important;\n  box-shadow: var(--shadow-glow) !important;\n  animation: lf-attention-pulse 0.6s ease-out 2;\n}\n\n@keyframes lf-attention-pulse {\n  0% {\n    transform: scale(1);\n  }\n  35% {\n    transform: scale(1.015);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n/* the callout is centred by a transform, so it needs its own keyframes */\n.detection-label .lf-canvas-callout--nudge {\n  animation-name: lf-attention-pulse-centered;\n}\n\n@keyframes lf-attention-pulse-centered {\n  0% {\n    transform: translateX(-50%) scale(1);\n  }\n  35% {\n    transform: translateX(-50%) scale(1.03);\n  }\n  100% {\n    transform: translateX(-50%) scale(1);\n  }\n}\n@media (max-width: 768px) {\n  .detection-label .lf-canvas-callout {\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n  }\n}\n/* ===== AI panel — pre-label from a trained version (model-in-the-loop) ===== */\n.auto-label-panel__prelabel {\n  padding-bottom: 0.75rem;\n  margin-bottom: 0.75rem;\n  border-bottom: 1px dashed var(--border);\n}\n\n.auto-label-panel__section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--foreground);\n}\n\n.auto-label-panel__section-title > i {\n  color: var(--primary);\n}\n\n.auto-label-panel__prelabel .progress {\n  background: var(--muted);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.auto-label-panel__prelabel .progress-bar {\n  background: var(--primary);\n  transition: width var(--transition);\n}\n\n.auto-label-panel__error {\n  display: block;\n  margin-top: 0.5rem;\n  padding: 0.4rem 0.5rem;\n  border-radius: var(--radius-sm);\n  background: var(--warning-soft);\n  color: var(--warning);\n  font-size: 0.72rem;\n  line-height: 1.35;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
